import $ from 'jquery';

class TermsExpand {
    /**
     * Constructor.
     *
     * @param termsExpandButton The class for the terms expand button.
     */
    constructor (termsExpandButton) {
        this.$termsExpandButton = $(termsExpandButton);
        this.termsExpandWrapperClass = '.js-terms-wrapper';
        this.termClass = '.js-term';

        this.$termsExpandButton.on('click', $.proxy(this.termsExpandClick, this));
    }

    /**
     * On click, add the open class and change aria expanded attribute.
     *
     * @param event The click event.
     */
    termsExpandClick (event) {
        const $element = $(event.target);
        const parent = $element.parents(this.termsExpandWrapperClass);

        parent.addClass('is-open');
        parent.find(this.termClass).attr('aria-expanded', 'true');
    }
}

export default TermsExpand;
